// Auth0 Login Errors: https://auth0.com/docs/libraries/common-auth0-library-authentication-errors#log-in
export enum Auth0LoginError {
    access_denied = 'access_denied',
    invalid_user_password = 'invalid_user_password',
    mfa_invalid_code = 'mfa_invalid_code',
    mfa_registration_required = 'mfa_registration_required',
    mfa_required = 'mfa_required',
    password_leaked = 'password_leaked',
    PasswordHistoryError = 'PasswordHistoryError',
    PasswordStrengthError = 'PasswordStrengthError',
    too_many_attempts = 'too_many_attempts',
    unauthorized = 'unauthorized',
}

export enum SPAError {
    // Request to platform/facade/user/active/compressed failed
    user_active_failed = 'user_active_failed',

    // User has no properties assigned to their account, so they can't do anything in Storyline
    no_available_targets = 'no_available_targets',

    // General login failure
    login_error = 'login_error',
}

export type LoginErrorTypes = keyof typeof SPAError | keyof typeof Auth0LoginError;
